// Single source of truth for the product category list, previously
// duplicated verbatim across Cracker.jsx, ProductSearch.jsx, NewProduct.jsx
// and UpdateProduct.jsx. Values and order are unchanged from the originals —
// this only removes the duplication, it does not add/remove any category.

export const CATEGORIES = [
  "Sound crackers",
  "Twinkling star",
  "Pencil",
  "Flower pot",
  "Ground chakkara",
  "Bijli crackers",
  "Bomb",
  "Rockets",
  "Continue crackers",
  "Special wala",
  "Fancy show",
  "Sky shot rider",
  "Branded sky shot",
  "Multi colour shot",
  "Flying crackers",
  "Peacock",
  "Standard fountain",
  "Mega fountain",
  "Flash novalties",
  "Varities",
  "Export oriented quality sparkles",
  "Sparklers",
  "Colour matches",
  "Gift box",
  "New Arrivals",
];
